import React from "react";
import { createPortal } from "react-dom";

export default function OverlayPortal({ children }) {
  const [container, setContainer] = React.useState(null);

  React.useEffect(() => {
    const el = document.createElement("div");
    el.setAttribute("data-overlay-root", "true");
    el.style.position = "fixed";
    el.style.inset = "0";
    el.style.zIndex = "10000";
    document.body.appendChild(el);
    setContainer(el);

    return () => {
      document.body.removeChild(el);
      setContainer(null);
    };
  }, []);

  if (!container) return null;

  return createPortal(children, container);
}
